import { Constants } from '../../util/Constants';
export default function TemplateLogo({ children }) {
  return (
    <div className={'template-logo'}>
      <img
        alt="template-logo"
        src={
          Constants.cloudinaryImage + children?.field_template_logo?.webimage
        }
      />
    </div>
  );
}
